import {isTruthy} from "@khanacademy/wonder-stuff-core";
import {AIActivity, UserPersona} from "@repo/guide-types";

import {getGuideActivitySlug} from "./get-guide-activity-slug.ts";

/**
 * Determine if a path represents the activities page.
 */
export const isActivitiesPage = (pathname: string): boolean =>
    isTruthy(getGuideActivitySlug(pathname));

/**
 * Determine if a path represents the default teacher activity page.
 */
export const isTeacherDefaultActivityPage = (pathname: string): boolean =>
    isUserDefaultActivityPage(pathname, UserPersona.Teacher);

/**
 * Determine if a path represents the default parent activity page.
 */
export const isParentDefaultActivityPage = (pathname: string): boolean =>
    isUserDefaultActivityPage(pathname, UserPersona.Parent);

/**
 * Determine if a path represents the default activity page for the user's
 * current persona.
 *
 * @param pathname
 * @param currentPersona
 */
export const isUserDefaultActivityPage = (
    pathname: string,
    currentPersona: UserPersona,
): boolean => {
    switch (currentPersona) {
        case UserPersona.Teacher:
            return getGuideActivitySlug(pathname) === AIActivity.DefaultTeacher;
        case UserPersona.Parent:
            return getGuideActivitySlug(pathname) === AIActivity.DefaultParent;
        default:
            return false;
    }
};
